var parent = require('../../es/instance/includes');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/includes.js
// module id = 1268
// module chunks = 25